/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStandortBenutzerZugriffDto } from '../../models/lexplus-standort-benutzer-zugriff-dto';

export interface StandorteControllerFindBenutzerZugriffeV1$Params {
  standortId: number;
}

export function standorteControllerFindBenutzerZugriffeV1(http: HttpClient, rootUrl: string, params: StandorteControllerFindBenutzerZugriffeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusStandortBenutzerZugriffDto>>> {
  const rb = new RequestBuilder(rootUrl, standorteControllerFindBenutzerZugriffeV1.PATH, 'get');
  if (params) {
    rb.path('standortId', params.standortId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusStandortBenutzerZugriffDto>>;
    })
  );
}

standorteControllerFindBenutzerZugriffeV1.PATH = '/v1/standorte/{standortId}/benutzer-zugriffe';
